function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Credit Card CVV
 * 
 */
import React, { Component } from 'react';
import TextInput from '../../../../components/text-input/TextInput';
import { cvv } from '../../../../actions/index';
import { connect } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
class CVV extends Component {
  render() {
    const {
      setCvv,
      creditCard,
      gateway
    } = this.props;
    const name = gateway.name === 'windcave' ? 'Cvc2' : gateway.name === 'securepay' ? 'EPS_CCV' : 'cvv';
    const values = {
      [name]: {
        ...creditCard.cvv
      }
    };
    return /*#__PURE__*/_jsx(TextInput, {
      label: "CCV",
      name: name,
      handleChange: setCvv,
      onBlur: setCvv
      // $FlowFixMe
      ,
      values: values,
      placeholder: "123",
      section: "",
      type: "tel",
      inputMode: "numeric"
    });
  }
}
_defineProperty(CVV, "defaultProps", {
  setCvv: () => null,
  creditCard: {
    cvv: {
      error: false,
      required: true,
      value: '',
      valid: null
    }
  },
  gateway: {
    name: 'windcave'
  }
});
const mapStateToProps = ({
  creditCard
}) => {
  return {
    creditCard
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setCvv: value => {
      dispatch(cvv(value));
    }
  };
};
const VisibleCVV = connect(mapStateToProps, mapDispatchToProps)(CVV);
export default VisibleCVV;